export const SDK_VERSION = '7.99.0';
